import React from 'react';
import QuizTemplate from './QuizTemplate';

function QuizAssociativeCreativity({pb}) {
   const questions = [
      {
        questionText: 'What is associative thinking?',
        answerOptions: [
          { answerText: 'Thinking creatively', isCorrect: false },
          { answerText: 'Ask your associate to give you ideas', isCorrect: false },
          { answerText: 'Connecting two different ideas', isCorrect: true },
        ],
      },
      {
        questionText: 'How did Curio combine a ball to make a better mug?',
        answerOptions: [
          { answerText: 'Attached the ball to the mug', isCorrect: false },
          { answerText: 'Used an attribute of ball to improve mug', isCorrect: true },
          { answerText: 'Juggled the ball and the mug', isCorrect: false },
        ],
      },
    ]

    return(
      <div className="m-3">
         <QuizTemplate data={questions} problem={pb} />
      </div>
    )

}

export default QuizAssociativeCreativity;